import { Currencies } from '@/entities/curency'
import { DatePicker } from '@/entities/datePicker/ui/DatePicker'
import CardIcon from '@/shared/assets/icons/card.svg?react'
import CrossIcon from '@/shared/assets/icons/cross.svg?react'
import FilterIcon from '@/shared/assets/icons/filter.svg?react'
import { BaseButton, BaseInput } from '@/shared/components'
import { ControlledSelect } from '@/shared/components/ControledFilterComponents/ControlledSelect'
import { useToast } from '@/shared/hooks'
import { OptionModel } from '@/shared/lib/types'
import { useEffect, useState } from 'react'
import { WithdrawStatus, withdrawStatusOptions } from '../../model'

export type WithdrawsStateType = {
  id?: string // Поиск по ID заявки

  countryto?: string // Поиск по стране получателя
  currencyto?: Currencies // Поиск по валюте получателя
  methodto?: string // Поиск по платежному методу получателя
  bankto?: string // Поиск по банку получателя

  amountfrom?: number // Поиск по сумме от (в валюте получателя)
  amountto?: number // Поиск по сумме до (в валюте получателя)

  createdfromutc: string // Поиск по дате создания от (UTC)
  createdtoutc: string // Поиск по дате создания до (UTC)

  confirmedFrom?: string // Поиск по дате подтверждения от
  confirmedTo?: string // Поиск по дате подтверждения до

  preq?: string // Поиск по платежному реквизиту
  withdrawStatus?: WithdrawStatus // Поиск по статусу заявки
}

const bankOptions: OptionModel[] = [{ label: 'Все', value: '', index: 0 }]

type FiltersWithdrawsProps = {
  onSubmit: (filters: WithdrawsStateType) => void
  onReset?: () => void
}

export const FiltersWithdraws = ({ onSubmit, onReset }: FiltersWithdrawsProps) => {
  // const now = new Date()
  // const initialDateUtc = now.toISOString()
  // const startOfDayUtc = new Date(
  //   Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  // )
  // const startDateUtc = startOfDayUtc.toISOString()
  const { addToast } = useToast()

  const initialFilters: WithdrawsStateType = {
    id: '',
    amountfrom: undefined,
    amountto: undefined,
    withdrawStatus: undefined,
    bankto: '',
    createdfromutc: '',
    createdtoutc: '',
    preq: '',
  }

  const [isOpen, setIsOpen] = useState(false)
  const [filters, setFilters] = useState<WithdrawsStateType>(initialFilters)

  const [error, setError] = useState('')

  useEffect(() => {
    if (error) {
      addToast('Ошибка!', error, 'error')
    }
  }, [error, setError])

  const handleFilterChange = (
    key: keyof WithdrawsStateType,
    value: string | number | null | undefined
  ) => {
    setFilters((prev) => ({ ...prev, [key]: value ?? '' }))
  }

  const handleReset = () => {
    setFilters(initialFilters)
    onReset?.()
    console.log('click')
  }

  const icon = isOpen ? (
    <CrossIcon className="text-primary dark:text-primary-dark" />
  ) : (
    <FilterIcon className="text-primary dark:text-primary-dark" />
  )

  return (
    <div className="mb-6">
      <div className="flex md:flex-row flex-col-reverse md:items-center gap-4 mb-6">
        <BaseButton
          onClick={() => {
            setIsOpen((prev) => {
              const next = !prev
              if (!next && onReset) onReset()
              return next
            })
          }}
          radius="lg"
          variant="setting"
          icon={icon}
          padding="none"
          className="px-4 py-2 min-w-[130px]"
        >
          {isOpen ? 'Закрыть' : 'Фильтры'}
        </BaseButton>
        <div className="flex items-center gap-x-4 w-full">
          <BaseInput
            className="w-full"
            placeholder="Введите ID для поиска транзакции"
            value={filters.id}
            onChange={(e) => handleFilterChange('id', e.target.value)}
          />
          <BaseButton radius="lg" onClick={() => onSubmit(filters)}>
            Найти
          </BaseButton>
        </div>
      </div>
      {isOpen && (
        <div className="flex flex-col gap-y-6 bg-light-purple dark:bg-dark-purple px-6 py-8 rounded-2xl text-sm">
          <p className="font-medium text-base">Фильтрация транзакций</p>
          <div className="flex md:flex-row flex-col flex-wrap gap-6 md:gap-y-4">
            <div className="w-full md:max-w-[220px]">
              <span className="inline-block mb-2 text-text-secondary whitespace-nowrap">
                Статус транзакции
              </span>
              <ControlledSelect
                options={withdrawStatusOptions}
                value={filters.withdrawStatus}
                onChange={(val) => handleFilterChange('withdrawStatus', val)}
              />
            </div>

            <div>
              <span className="inline-block mb-2 text-text-secondary whitespace-nowrap">
                Сумма сделки
              </span>
              <div className="flex items-center gap-x-2">
                <BaseInput
                  placeholder="От"
                  className="md:max-w-[100px]"
                  value={filters.amountfrom?.toString() ?? ''}
                  onChange={(e) =>
                    handleFilterChange(
                      'amountfrom',
                      e.target.value ? Number(e.target.value.replace(/\D/g, '')) : undefined
                    )
                  }
                />
                <div className="w-4 h-[1px] bg-text-secondary"></div>
                <BaseInput
                  placeholder="До"
                  className="md:max-w-[100px]"
                  value={filters.amountto?.toString() ?? ''}
                  onChange={(e) =>
                    handleFilterChange(
                      'amountto',
                      e.target.value ? Number(e.target.value.replace(/\D/g, '')) : undefined
                    )
                  }
                />
              </div>
            </div>

            <div>
              <span className="inline-block mb-2 text-text-secondary whitespace-normal">
                Дата создания транзакций
              </span>
              <div className="flex items-center gap-x-2 w-full">
                <DatePicker
                  variant="outline"
                  placeholder="Дата, от"
                  className="flex-row-reverse flex-1 justify-between !pr-2 !pl-3 !text-sm"
                  monthButton={false}
                  value={filters.createdfromutc ? new Date(filters.createdfromutc) : undefined}
                  onDateChange={(date) => {
                    const newStartDate = date.toISOString()
                    if (!filters.createdtoutc || new Date(filters.createdtoutc) >= date) {
                      handleFilterChange('createdfromutc', newStartDate)
                    } else {
                      setError('Дата начала не может быть позже даты окончания')
                    }
                  }}
                />
                <div className="w-4 h-[1px] bg-text-secondary"></div>
                <DatePicker
                  variant="outline"
                  placeholder="Дата, до"
                  className="flex-row-reverse flex-1 justify-between !pr-2 !pl-3 !text-sm"
                  monthButton={false}
                  value={filters.createdtoutc ? new Date(filters.createdtoutc) : undefined}
                  onDateChange={(date) => {
                    const newEndDate = date.toISOString()
                    if (date >= new Date(filters.createdfromutc)) {
                      handleFilterChange('createdtoutc', newEndDate)
                    } else {
                      setError('Дата окончания не может быть раньше даты начала')
                    }
                  }}
                />
              </div>
            </div>
            <div className="w-full md:max-w-[220px]">
              <span className="inline-block mb-2 text-text-secondary">Банк</span>
              <ControlledSelect
                options={bankOptions}
                value={filters.bankto}
                onChange={(val) => handleFilterChange('bankto', val)}
              />
            </div>
            <div>
              <span className="inline-block mb-2 text-text-secondary whitespace-nowrap">
                Реквизит
              </span>
              <BaseInput
                placeholder="Карта/Номер счета/Телефон"
                leftIcon={<CardIcon className="text-primary dark:text-primary-dark" />}
                variant="secondary"
                className="w-full"
                value={filters.preq}
                onChange={(e) => handleFilterChange('preq', e.target.value.replace(/\D/g, ''))}
              />
            </div>
          </div>
          <div className="flex md:flex-row flex-col gap-2 md:gap-6">
            <BaseButton radius="lg" icon={<FilterIcon />} onClick={() => onSubmit(filters)}>
              Применить
            </BaseButton>
            <BaseButton
              onClick={handleReset}
              radius="lg"
              variant="ghost"
              icon={<CrossIcon className="text-primary" />}
              className="bg-light-bg dark:bg-dark-bg"
            >
              Сбросить фильтры
            </BaseButton>
          </div>
        </div>
      )}
    </div>
  )
}
